import React from 'react'
import { connect } from 'react-redux'
import { LoginPage as LoginPageComponent } from '../LoginPage'
import { Form } from '../../AuthNative'
import { LoginButton as GoogleButton } from '../../AuthGoogle'
import { FirefoxButton } from '../../AuthFirefox'

const getErrorMessage = (state) => {
  const error = state.googleAuth.error || state.login.error

  return error ? error.message : state.login.errorHtml
}

const mapStateToProps = (state, params) => {
  const dict     = state.localization.dictionary.login
  const errorMsg = getErrorMessage(state)
  const message  = state.login.messageHtml

  return {
    dict,
    errorMsg,
    message
  }
}

const onSuccess = (response) => {
  window.location.assign(response.locationUrl)
}

const onError = (error, user) => {
  if (error.id === 5107) {
    // Captcha or CSRF error
    // Show login with appropriate error message
    window.location.assign('/login?e=24')
  }
  else if (error.id === 5104) {
    // Google authed but not recognized account. Create it?
    window.location.assign(`/signup_interim?email=${user.email}`)
  }
}

const LoginPage = (props) => {
  return (
    <LoginPageComponent
      dict={ props.dict }
      messageHtml={ props.message }
      errorHtml={ props.errorMsg }
      top={
        <div>
          <GoogleButton
            onError={ onError }
            onSuccess={ onSuccess } />
          <FirefoxButton />
        </div>
      }
      bottom={
        <Form
          onError={ onError }
          onSuccess={ onSuccess } />
      }
    />
  )
}

const LoginPageConnected = connect(
  mapStateToProps
)(LoginPage)

export {
  LoginPageConnected as LoginPage
}
